import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AsyncPipe, DecimalPipe} from "@angular/common";
import {Button} from "primeng/button";
import {Dialog} from "primeng/dialog";
import {Fluid} from "primeng/fluid";
import {InputNumber} from "primeng/inputnumber";
import {PrimeTemplate} from "primeng/api";
import {Forecast} from '../forecast/forecast';
import {ForecastDetailService} from '../forecast-detail/forecast-detail.service';
import {SubsidiaryService} from '../subsidiary/subsidiary.service';
import {Observable} from 'rxjs';
import {SubsidiaryCollection} from '../subsidiary/subsidiary-collection';
import {FormsModule} from '@angular/forms';
import {ForecastDetailCollection} from '../forecast-detail/forecast-detail-collection';

@Component({
  selector: 'app-allocate-goods',
    imports: [
        AsyncPipe,
        Button,
        DecimalPipe,
        Dialog,
        Fluid,
        InputNumber,
        PrimeTemplate,
        FormsModule
    ],
  templateUrl: './allocate-goods.html',
  styleUrl: './allocate-goods.scss',
})
export class AllocateGoods implements OnInit {

    @Input() public forecast!: Forecast;
    @Output() protected visibleChange = new EventEmitter<boolean>();
    @Output() protected saved = new EventEmitter<ForecastDetailCollection>();

    protected subsidiaries$!: Observable<SubsidiaryCollection>;
    protected allocatedQuantities: Record<string, number> = {};
    protected allocatedQuantitiesBeforeChange: Record<string, number> = {};

    private _visible = false;

    constructor(
        private forecastDetailService: ForecastDetailService,
        private subsidiaryService: SubsidiaryService
    ) {
    }

    ngOnInit(): void {
        this.subsidiaries$ = this.subsidiaryService.getAll();
    }

    get visible(): boolean {
        return this._visible;
    }

    @Input() set visible(value: boolean) {
        this._visible = value;

        if (value && this.forecast) {
            this.allocatedQuantities             = {};
            this.allocatedQuantitiesBeforeChange = {};

            for (const detail of this.forecast.forecastDetails) {
                if (detail.allocatedQuantity !== null) {
                    this.allocatedQuantities[detail.subsidiary.id]             = detail.allocatedQuantity;
                    this.allocatedQuantitiesBeforeChange[detail.subsidiary.id] = detail.allocatedQuantity;
                }
            }
        }
    }

    protected closeModal(): void {
        this.visibleChange.emit(false);
    }

    protected updateForecastAllocation(): void {
        this.forecastDetailService
            .updateAllocations(this.forecast, this.allocatedQuantities)
            .subscribe(collection => {
                this.saved.emit(collection);
                this.closeModal();
            });
    }

    protected hasAllocation(subsidiaryId: string): boolean {
        return subsidiaryId in this.allocatedQuantitiesBeforeChange;
    }
}
